/* GoodyBro quick add popup. A [data-qa-open="<product url>"] button opens it. */
(function () {
  'use strict';
  if (window.GBQuickAdd) return;

  const SIZE_RE = /^(size|sizes|সাইজ|মাপ)$/i;
  let dlg, panel, state, trigger;

  const t = (k, d) => (window.GB && GB.strings && GB.strings[k]) || d;
  const money = (c) => (window.GB && GB.formatMoney ? GB.formatMoney(c) : (c / 100).toFixed(0));
  const sized = (url, w) => url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '';

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'gb-qa';
    dlg.setAttribute('aria-labelledby', 'gb-qa-title');
    dlg.innerHTML =
      '<div class="gb-qa__panel">' +
        '<button type="button" class="gb-qa__close" data-qa-close aria-label="Close">&times;</button>' +
        '<div class="gb-qa__head">' +
          '<div class="gb-qa__img"></div>' +
          '<div class="gb-qa__meta"><a class="gb-qa__title" id="gb-qa-title"></a><div class="gb-qa__price"></div></div>' +
        '</div>' +
        '<div class="gb-qa__opts"></div>' +
        '<p class="gb-qa__err" role="alert" hidden></p>' +
        '<button type="button" class="gb-qa__add" data-qa-add></button>' +
        '<a class="gb-qa__more"></a>' +
      '</div>';
    document.body.appendChild(dlg);
    panel = dlg.querySelector('.gb-qa__panel');

    dlg.addEventListener('click', (e) => {
      if (e.target === dlg || e.target.closest('[data-qa-close]')) { close(); return; }
      const v = e.target.closest('[data-qa-val]');
      if (v) { if (!v.disabled) pick(parseInt(v.dataset.qaIdx, 10), v.dataset.qaVal); return; }
      if (e.target.closest('[data-qa-add]')) add();
    });
    dlg.addEventListener('close', () => {
      if (trigger && trigger.focus) trigger.focus();
    });
  }

  function optName(o) { return typeof o === 'string' ? o : (o && o.name) || ''; }

  function open(url, btn, opts) {
    if (!dlg) build();
    trigger = btn;
    if (btn) btn.classList.add('is-loading');
    const clean = url.split('?')[0].split('#')[0].replace(/\/$/, '');
    fetch(clean + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => { if (!r.ok) throw new Error('fetch'); return r.json(); })
      .then((p) => {
        const names = (p.options || []).map(optName);
        const values = names.map((_, i) => {
          const seen = [];
          p.variants.forEach((v) => { if (seen.indexOf(v.options[i]) === -1) seen.push(v.options[i]); });
          return seen;
        });
        const first = p.variants.find((v) => v.available) || p.variants[0];
        const sel = names.map((n, i) => {
          if (values[i].length === 1) return values[i][0];
          if (SIZE_RE.test(n.trim())) return null;
          return first.options[i];
        });
        const o = opts || {};
        const pre = o.variantId && p.variants.find((x) => String(x.id) === String(o.variantId) && x.available);
        if (pre) pre.options.forEach((val, i) => { sel[i] = val; });
        state = { p, names, values, sel, url: clean, opts: o };
        render();
        if (dlg.showModal) { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
      })
      .catch(() => { window.location.href = url; })
      .finally(() => { if (btn) btn.classList.remove('is-loading'); });
  }

  function close() {
    if (!dlg) return;
    if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
  }

  function current() {
    if (state.sel.some((s) => s == null)) return null;
    return state.p.variants.find((v) => v.options.every((o, i) => o === state.sel[i])) || null;
  }

  function valueAvailable(idx, val) {
    return state.p.variants.some((v) => v.available && v.options[idx] === val &&
      v.options.every((o, i) => i === idx || state.sel[i] == null || o === state.sel[i]));
  }

  function pick(idx, val) {
    state.sel[idx] = val;
    for (let i = 0; i < state.sel.length; i++) {
      if (i !== idx && state.sel[i] != null && !valueAvailable(i, state.sel[i])) state.sel[i] = null;
    }
    hideErr();
    render();
  }

  function render() {
    const { p, names, values, sel } = state;
    const v = current();

    const title = panel.querySelector('.gb-qa__title');
    title.textContent = p.title;
    title.href = state.url;

    const shown = v || p.variants.find((x) => x.available) || p.variants[0];
    const price = panel.querySelector('.gb-qa__price');
    price.textContent = '';
    const now = document.createElement('span');
    now.textContent = (!v && p.price_varies ? (t('from', 'From') + ' ') : '') + money(v ? v.price : p.price);
    price.appendChild(now);
    const cmp = v ? v.compare_at_price : null;
    if (cmp && cmp > v.price) { const s = document.createElement('s'); s.textContent = money(cmp); price.appendChild(s); }

    const imgWrap = panel.querySelector('.gb-qa__img');
    const src = (shown && shown.featured_image && shown.featured_image.src) || p.featured_image;
    imgWrap.textContent = '';
    if (src) {
      const img = document.createElement('img');
      img.src = sized(src.indexOf('//') === 0 ? 'https:' + src : src, 240);
      img.alt = '';
      img.width = 72; img.height = 96;
      imgWrap.appendChild(img);
    }

    const box = panel.querySelector('.gb-qa__opts');
    box.textContent = '';
    if (!(p.variants.length === 1 && /default title/i.test(p.variants[0].title))) {
      names.forEach((name, i) => {
        if (values[i].length < 2 && !SIZE_RE.test(name.trim())) return;
        const row = document.createElement('div');
        row.className = 'gb-qa__opt';
        const label = document.createElement('div');
        label.className = 'gb-qa__label';
        label.textContent = name;
        if (sel[i] != null) { const b = document.createElement('b'); b.textContent = sel[i]; label.appendChild(b); }
        const vals = document.createElement('div');
        vals.className = 'gb-qa__vals';
        vals.setAttribute('role', 'group');
        vals.setAttribute('aria-label', name);
        const hideOOS = document.body.classList.contains('gb-hide-oos') && SIZE_RE.test(name.trim());
        let shownCount = 0;
        values[i].forEach((val) => {
          const avail = valueAvailable(i, val);
          if (hideOOS && !avail) return;
          shownCount++;
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'gb-qa__val';
          btn.dataset.qaIdx = i;
          btn.dataset.qaVal = val;
          btn.textContent = val;
          btn.setAttribute('aria-pressed', sel[i] === val ? 'true' : 'false');
          if (!avail) btn.disabled = true;
          vals.appendChild(btn);
        });
        if (hideOOS && shownCount === 0) {
          const none = document.createElement('p');
          none.className = 'gb-qa__none';
          none.textContent = 'All sizes are sold out in this option.';
          vals.appendChild(none);
        }
        row.appendChild(label);
        row.appendChild(vals);
        box.appendChild(row);
      });
    }

    const addBtn = panel.querySelector('.gb-qa__add');
    if (v && !v.available) addBtn.textContent = t('soldOut', 'Sold out');
    else addBtn.textContent = (state.opts.label || t('addToCart', 'Add to bag')) + (v ? ' · ' + money(v.price) : '');

    const more = panel.querySelector('.gb-qa__more');
    more.href = state.url;
    more.textContent = 'View full details';
  }

  function missingName() {
    const i = state.sel.findIndex((s) => s == null);
    return i > -1 ? state.names[i].toLowerCase() : '';
  }

  function showErr(msg) {
    const e = panel.querySelector('.gb-qa__err');
    e.textContent = msg;
    e.hidden = false;
  }
  function hideErr() { const e = panel.querySelector('.gb-qa__err'); if (e) e.hidden = true; }

  function add() {
    const v = current();
    if (!v) { showErr('Choose a ' + (missingName() || 'option') + ' first.'); return; }
    if (!v.available) { showErr(t('soldOut', 'Sold out')); return; }
    const btn = panel.querySelector('.gb-qa__add');
    btn.classList.add('is-loading');
    btn.disabled = true;
    const done = () => { btn.classList.remove('is-loading'); btn.disabled = false; };
    if (!window.GB || !GB.addToCart) { window.location.href = state.url + '?variant=' + v.id; return; }
    close();
    GB.addToCart({ id: v.id, quantity: state.opts.quantity || 1 }, { checkout: !!state.opts.checkout })
      .catch((ex) => { if (GB.toast) GB.toast(ex.message); })
      .finally(done);
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qa-open]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    open(b.dataset.qaOpen, b);
  });

  /* Product page: hide sold out sizes and keep a valid size selected */
  const PP_SIZE_RE = /^\s*(size|sizes|সাইজ|মাপ)\b/i;
  function tagSizeFieldsets(root) {
    (root || document).querySelectorAll('gb-product [data-option]').forEach((fs) => {
      const legend = fs.querySelector('legend');
      if (legend && PP_SIZE_RE.test(legend.textContent)) fs.classList.add('gb-option--size');
    });
  }
  function fixSizeSelection(product) {
    if (!document.body.classList.contains('gb-hide-oos')) return;
    product.querySelectorAll('.gb-option--size').forEach((fs) => {
      const checked = fs.querySelector('input:checked');
      if (checked && checked.classList.contains('is-unavailable')) {
        const next = fs.querySelector('input:not(.is-unavailable)');
        if (next) { next.checked = true; next.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      const any = fs.querySelector('input:not(.is-unavailable)');
      fs.classList.toggle('gb-option--none-left', !any);
    });
  }
  function initProductPages() {
    tagSizeFieldsets();
    document.querySelectorAll('gb-product').forEach((p) => fixSizeSelection(p));
  }
  document.addEventListener('change', (e) => {
    const p = e.target.closest && e.target.closest('gb-product');
    if (p && e.target.closest('[data-option]') && !e.target.closest('.gb-option--size')) {
      setTimeout(() => fixSizeSelection(p), 0);
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductPages);
  else initProductPages();
  document.addEventListener('shopify:section:load', (e) => { tagSizeFieldsets(e.target); e.target.querySelectorAll('gb-product').forEach((p) => fixSizeSelection(p)); });

  window.GBQuickAdd = { open, close };
})();
